<template>
    <branded-split-screen
        heading="Reset your password"
        description="Choose a new password to get back to managing your feature flags."
    >
        <h2 class="text-2xl font-semibold text-taupe-900 dark:text-taupe-50">
            Reset your password
        </h2>

        <div v-if="error" class="mt-8 text-taupe-600 dark:text-taupe-300">
            {{ error }}
        </div>

        <div v-if="success" class="mt-8 space-y-4">
            <h3 class="text-xl font-medium text-taupe-900 dark:text-taupe-50">
                Congratulations!
            </h3>
            <p class="text-taupe-600 dark:text-taupe-300">
                Your password's reset. You can log in now.
            </p>
            <p>
                <router-link
                    :to="{ name: 'LoginScreen' }"
                    class="font-medium text-sky-500 dark:text-sky-400 hover:text-sky-600 dark:hover:text-sky-300"
                    >Login to your account</router-link
                >
            </p>
        </div>
        <form
            v-if="!success && !error"
            @submit.prevent="submit"
            @keydown.enter="submitFormOnEnter"
            class="mt-8 space-y-6"
        >
            <zen-message-block v-if="message" type="error">
                {{ message }}
            </zen-message-block>
            <div>
                <label
                    for="password"
                    class="block font-medium text-taupe-800 dark:text-taupe-100"
                >
                    Password
                </label>
                <div class="mt-1">
                    <input
                        id="password"
                        name="password"
                        type="password"
                        autocomplete="current-password"
                        required
                        v-model="form.password"
                        class="appearance-none block w-full px-3 py-2 border border-taupe-300 rounded-md shadow-xs placeholder-taupe-400 dark:placeholder-taupe-500 focus:outline-hidden focus:ring-sky-500 focus:border-sky-500 dark:border-taupe-600 dark:bg-taupe-800 dark:text-taupe-50"
                    />
                </div>
            </div>

            <div>
                <label
                    for="confirm_password"
                    class="block font-medium text-taupe-800 dark:text-taupe-100"
                >
                    Confirm password
                </label>
                <div class="mt-1">
                    <input
                        id="confirm_password"
                        name="confirm_password"
                        type="password"
                        autocomplete="current-password"
                        required
                        v-model="form.confirm_password"
                        class="appearance-none block w-full px-3 py-2 border border-taupe-300 rounded-md shadow-xs placeholder-taupe-400 dark:placeholder-taupe-500 focus:outline-hidden focus:ring-sky-500 focus:border-sky-500 dark:border-taupe-600 dark:bg-taupe-800 dark:text-taupe-50"
                    />
                </div>
            </div>

            <div>
                <zen-button
                    type="submit"
                    variant="primary"
                    size="large"
                    full-width
                    :processing="loading"
                >
                    Reset Password
                </zen-button>
            </div>
        </form>
    </branded-split-screen>
</template>

<script>
import BrandedSplitScreen from '@/screens/_components/BrandedSplitScreen.vue'
import AuthPasswordService from '@/services/auth.password.service'
import { submitFormOnEnter } from '@/utils/form-submit'

export default {
    components: {
        BrandedSplitScreen,
    },
    data() {
        return {
            form: {
                password: '',
                confirm_password: '',
            },
            error: null,
            loading: false,
            success: false,
            message: '',
        }
    },
    methods: {
        submitFormOnEnter,
        submit() {
            this.loading = true
            AuthPasswordService.confirm(
                this.$route.params.token,
                this.form
            ).then(
                () => {
                    this.success = true
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                    this.message = error
                }
            )
        },
    },
    mounted() {
        this.loading = true
        AuthPasswordService.check(this.$route.params.token).then((result) => {
            this.loading = false
            if (!result) {
                this.error =
                    "This password reset link isn't valid — it may have expired or already been used."
            }
        })
    },
}
</script>
